import { THEME_ID, type ThemeId } from '../../themes/types';

export interface AboutUsCopy {
  headline: string;
  paragraphs: string[];
}

const KINDLY_HUMAN_ABOUT: AboutUsCopy = {
  headline: 'Kindly Human is built on a simple belief: connection can change how we experience life.',
  paragraphs: [
    'Everyone moves through life in their own way, across moments of joy, growth, uncertainty, and reflection. Often, what matters most is feeling understood. Through real stories, shared experiences, and thoughtful guidance, Kindly Human creates space for everyone to recognize themselves in others and experience connection without pressure or expectation.',
    'This experience is designed to feel intuitive and familiar. It brings together content that reflects real life moments, perspectives that resonate, and pathways that support exploration in a way that feels natural. The goal is not to direct a single path forward, but to make it easier to find something that connects and helps shape what comes next.',
    'Not every moment starts with a clear answer, but connection can help make the next step feel possible.',
  ],
};

const KINDLY_CHRISTIAN_ABOUT: AboutUsCopy = {
  headline:
    'Kindly Christian is built on a simple belief: connection, grounded in faith, can shape how people experience life.',
  paragraphs: [
    'Everyone moves through life differently, across moments of joy, growth, uncertainty, and reflection. Often, what matters most is feeling understood and connected to others who share a foundation of faith. Through real stories, shared experiences, and faith-centered perspectives, Kindly Christian creates space for people to recognize themselves in others and experience connection without pressure or expectation.',
    'This experience is designed to feel intuitive and familiar. It brings together content that reflects everyday life, perspectives shaped by faith, and a collection of faith-based resources in one place, making it easier to find what resonates and engage in a way that feels natural.',
    'Not every moment comes with complete clarity, but faith and connection can help guide what comes next.',
  ],
};

const BY_THEME: Record<ThemeId, AboutUsCopy> = {
  [THEME_ID.KINDLY]: KINDLY_HUMAN_ABOUT,
  [THEME_ID.KINDLY_CHRISTIAN]: KINDLY_CHRISTIAN_ABOUT,
};

export function getAboutUsCopy(themeId: ThemeId): AboutUsCopy {
  return BY_THEME[themeId];
}
